export enum ClaimStatusTypes {
  UNCLAIMED = 'unclaimed',
  PENDING = 'pending',
  ACCEPTED = 'claimed',
  REJECTED = 'denied',
}
